import React from "react";
import Header from "../../../components/molecules/Header";
import {
  Container,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  ListItemIcon,
  IconButton,
  List,
  ListSubheader,
  Button,
  Avatar,
  Divider,
  Typography,
} from "@material-ui/core";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import DnsIcon from "@material-ui/icons/Dns";
import RedeemIcon from "@material-ui/icons/Redeem";
import ChromeReaderModeIcon from "@material-ui/icons/ChromeReaderMode";
import SettingsIcon from "@material-ui/icons/Settings";
import SmartphoneIcon from "@material-ui/icons/Smartphone";
import LocalMallIcon from "@material-ui/icons/LocalMall";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import CreditCardIcon from "@material-ui/icons/CreditCard";
import LanguageIcon from "@material-ui/icons/Language";
import YouTubeIcon from "@material-ui/icons/YouTube";
import TelegramIcon from "@material-ui/icons/Telegram";
import InstagramIcon from "@material-ui/icons/Instagram";
import FacebookIcon from "@material-ui/icons/Facebook";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";
import StoreIcon from "@material-ui/icons/Store";
import Gap from "../../../components/atoms/Gap";
import Logo from "../../../assets/icon/LogoMarket";
import { useData } from "../../../components/firebase/DataProvider";
import { useHistory } from "react-router-dom";
import DefaultLogo from "../../../assets/images/landing-image-third.png";
// useStyles
import useStyles from "./style";
import CopyToClipboard from "react-copy-to-clipboard";
import { useSnackbar } from "notistack";
import { MenuBook } from "@material-ui/icons";

function Akun() {
  const classes = useStyles();

  const { phone, profil, webstore, global_settings } = useData();

  const history = useHistory();

  const { enqueueSnackbar } = useSnackbar();

  const domainProd = `https://${webstore.domain}.tokorame.store`;
  const domainDevelop = `https://${webstore.domain}.tukuyok.net`;

  const lmsUrl = "https://www.tokorame.academy?ref=webapp";

  return (
    <>
      <Header type="with-title-cart" title="Akun" />
      <Container>
        <div className={classes.wrapHeader}>
          <div className={classes.wrapAvatar}>
            <Avatar
              className={classes.large}
              src={!webstore.logo ? DefaultLogo : webstore.logo}
            />
          </div>
          <Gap width={16} />
          <div>
            <Typography style={{ fontWeight: "bold" }}>
              {profil.nama}
            </Typography>
            <Typography style={{ fontSize: 14 }}>{phone?.id}</Typography>
            <Typography style={{ fontSize: 14 }}>{webstore?.nama}</Typography>
            {process.env.REACT_APP_FIREBASE_PROD === "YES" ? (
              <div style={{ display: "flex", alignItems: "center" }}>
                <Typography
                  color="primary"
                  style={{ fontSize: 14, cursor: "pointer" }}
                  onClick={() => window.open(domainProd)}
                >
                  {domainProd}
                </Typography>
                <CopyToClipboard
                  text={domainProd}
                  onCopy={() => {
                    enqueueSnackbar("Domain Toko Berhasil Disalin", {
                      variant: "success",
                    });
                  }}
                >
                  <FileCopyOutlinedIcon
                    color="primary"
                    style={{ fontSize: 14, marginLeft: 7.5, cursor: "pointer" }}
                  />
                </CopyToClipboard>
              </div>
            ) : (
              <div style={{ display: "flex", alignItems: "center" }}>
                <Typography
                  color="primary"
                  style={{ fontSize: 14, cursor: "pointer" }}
                  onClick={() => window.open(domainDevelop)}
                >
                  {domainDevelop}
                </Typography>
                <CopyToClipboard
                  text={domainDevelop}
                  onCopy={() => {
                    enqueueSnackbar("Domain Toko Berhasil Disalin", {
                      variant: "success",
                    });
                  }}
                >
                  <FileCopyOutlinedIcon
                    color="primary"
                    style={{ fontSize: 14, marginLeft: 7.5, cursor: "pointer" }}
                  />
                </CopyToClipboard>{" "}
              </div>
            )}
          </div>
        </div>
        <div className={classes.btnTokoSaya}>
          <Button
            variant="outlined"
            color="primary"
            size="small"
            fullWidth
            startIcon={<StoreIcon />}
            onClick={() => history.push("/tokosaya")}
          >
            Toko Saya
          </Button>
        </div>
      </Container>
      <div className={classes.wrapList}>
        <List
          className={classes.listPadding}
          subheader={
            <ListSubheader className={classes.list} disableSticky={true}>
              Transaksi
            </ListSubheader>
          }
        >
          <ListItem
            button
            onClick={() =>
              history.push("/transaksi/transaksilist/sellerapp/tokorame")
            }
          >
            <ListItemIcon>
              <SmartphoneIcon color="secondary" />
            </ListItemIcon>
            <ListItemText
              primary="Transaksi Via Tokorame"
              secondary="Lihat daftar transaksi yang telah terjadi melalui apk
                  tokorame"
            />
            <ListItemSecondaryAction>
              <IconButton
                edge="end"
                size="small"
                onClick={() =>
                  history.push("/transaksi/transaksilist/sellerapp/tokorame")
                }
              >
                <NavigateNextIcon />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
          <Divider />
          <ListItem
            button
            onClick={() =>
              history.push("/transaksi/transaksilist/webstore/webstore")
            }
          >
            <ListItemIcon>
              <LocalMallIcon color="primary" />
            </ListItemIcon>
            <ListItemText
              primary="Transaksi Via Webstore"
              secondary="Lihat daftar transaksi yang telah terjadi melalui Webstore"
            />
            <ListItemSecondaryAction>
              <IconButton
                edge="end"
                size="small"
                onClick={() =>
                  history.push("/transaksi/transaksilist/webstore/webstore")
                }
              >
                <NavigateNextIcon />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
          <Divider />
          <ListItem
            button
            onClick={() => history.push("/transaksi/pencairansaya")}
          >
            <ListItemIcon>
              <AttachMoneyIcon color="secondary" />
            </ListItemIcon>
            <ListItemText
              primary="Pencairan Kredit"
              secondary="Lihat daftar pencairan anda"
            />
            <ListItemSecondaryAction>
              <IconButton
                edge="end"
                size="small"
                onClick={() => history.push("/transaksi/pencairansaya")}
              >
                <NavigateNextIcon />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
          <Divider />
          <ListItem button onClick={() => history.push("/akun/rekening")}>
            <ListItemIcon>
              <CreditCardIcon color="primary" />
            </ListItemIcon>
            <ListItemText
              primary="Nomor Rekening Terdaftar"
              secondary="Lihat daftar rekening anda"
            />
            <ListItemSecondaryAction>
              <IconButton
                edge="end"
                size="small"
                onClick={() => history.push("/akun/rekening")}
              >
                <NavigateNextIcon />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
        </List>

        {global_settings.aktivasi_perhitungan_point === true && (
          <>
            {global_settings.aktivasi_reward_poin === true && (
              <>
                <List
                  className={classes.listPadding}
                  subheader={
                    <ListSubheader
                      className={classes.list}
                      disableSticky={true}
                    >
                      Reward Saya
                    </ListSubheader>
                  }
                >
                  <ListItem
                    button
                    onClick={() => history.push("/akun/rewardpoint")}
                  >
                    <ListItemIcon>
                      <RedeemIcon color="secondary" />
                    </ListItemIcon>
                    <ListItemText
                      primary="Reward Point"
                      secondary="Tukar coin anda dengan segala jenis hadiah yang telah
                      tersedia, ayok buruan!"
                    />
                    <ListItemSecondaryAction>
                      <IconButton
                        edge="end"
                        size="small"
                        onClick={() => history.push("/akun/rewardpoint")}
                      >
                        <NavigateNextIcon />
                      </IconButton>
                    </ListItemSecondaryAction>
                  </ListItem>
                  {/* <Divider /> */}
                </List>
              </>
            )}
          </>
        )}
        <List
          className={classes.listPadding}
          subheader={
            <ListSubheader className={classes.list} disableSticky={true}>
              Fitur Member
            </ListSubheader>
          }
        >
          <ListItem button onClick={() => history.push("/akun/pengaturan")}>
            <ListItemIcon>
              <SettingsIcon color="primary" />
            </ListItemIcon>
            <ListItemText primary="Pengaturan Akun" secondary="Lihat dan atur preferensi akun anda." />
            <ListItemSecondaryAction>
              <IconButton
                edge="end"
                size="small"
                onClick={() => history.push("/akun/pengaturan")}
              >
                <NavigateNextIcon />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
          <Divider />
          {global_settings?.aktivasi_akses_lms && (
            <>
              <ListItem button onClick={() => window.open(lmsUrl, "_blank")}>
              <ListItemIcon>
                <MenuBook color="primary" />
              </ListItemIcon>
              <ListItemText primary="LMS" secondary="Belajar Kapan Saja, Di Mana Saja." />
              <ListItemSecondaryAction>
                <IconButton
                  edge="end"
                  size="small"
                  onClick={() => window.open(lmsUrl, "_blank")}
                >
                  <NavigateNextIcon />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
            <Divider />
            </>
          )}
          <ListItem button onClick={() => window.open("/stock-available")}>
            <ListItemIcon>
              <DnsIcon color="secondary" />
            </ListItemIcon>
            <ListItemText primary="List Stok Produk" secondary="Lihat seluruh list stok produk tokorame." />
            <ListItemSecondaryAction>
              <IconButton edge="end" size="small">
                <NavigateNextIcon />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
        </List>
        <List
          className={classes.listPadding}
          component="nav"
          subheader={
            <ListSubheader className={classes.list} disableSticky={true}>
              Tentang TokoRame
            </ListSubheader>
          }
        >
          <ListItem
            button
            onClick={() =>
              window.open("https://www.facebook.com/groups/189482992873307")
            }
          >
            <ListItemIcon>
              <ChromeReaderModeIcon color="primary" />
            </ListItemIcon>
            <ListItemText primary="Grup FB Reseller" />
            <ListItemSecondaryAction>
              <IconButton edge="end" size="small">
                <NavigateNextIcon />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
          <Divider />
          <ListItem
            button
            onClick={() => window.open("https://tokorame.co.id/blog")}
          >
            <ListItemIcon>
              <LanguageIcon color="primary" />
            </ListItemIcon>
            <ListItemText primary="Blog Tokorame" />
            <ListItemSecondaryAction>
              <IconButton edge="end" size="small">
                <NavigateNextIcon />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
          <Divider />
          <ListItem
            button
            onClick={() =>
              window.open("https://www.youtube.com/watch?v=uEvjev6x0eM")
            }
          >
            <ListItemIcon>
              <YouTubeIcon color="secondary" />
            </ListItemIcon>
            <ListItemText primary="Video Tutorial Berjualan" />
            <ListItemSecondaryAction>
              <IconButton edge="end" size="small">
                <NavigateNextIcon />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
          <Divider />
          <ListItem
            button
            onClick={() => window.open("https://t.me/mitratokorame")}
          >
            <ListItemIcon>
              <TelegramIcon color="primary" />
            </ListItemIcon>
            <ListItemText primary="Chanel Telegram Seller" />
            <ListItemSecondaryAction>
              <IconButton edge="end" size="small">
                <NavigateNextIcon />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
          <Divider />
          <ListItem
            button
            onClick={() =>
              window.open("https://www.instagram.com/tokorameofficial/")
            }
          >
            <ListItemIcon>
              <InstagramIcon color="secondary" />
            </ListItemIcon>
            <ListItemText primary="Instagram Tokorame" />
            <ListItemSecondaryAction>
              <IconButton edge="end" size="small">
                <NavigateNextIcon />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
          <Divider />
          <ListItem
            button
            onClick={() =>
              window.open("https://www.facebook.com/tokorameofficial")
            }
          >
            <ListItemIcon>
              <FacebookIcon color="primary" />
            </ListItemIcon>
            <ListItemText primary="Facebook Tokorame" />
            <ListItemSecondaryAction>
              <IconButton edge="end" size="small">
                <NavigateNextIcon />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
          {/* <Divider />
          <ListItem button onClick={() => history.push("/akun/feedback")}>
            <ListItemIcon>
              <RateReviewIcon color="primary" />
            </ListItemIcon>
            <ListItemText primary="Beri Masukan" />
            <ListItemSecondaryAction>
              <IconButton edge="end" size="small">
                <NavigateNextIcon />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem> */}
        </List>
        <List>
          <ListItem button onClick={() => history.push("/akun/bantuan")}>
            <ListItemIcon>
              <Logo />
            </ListItemIcon>
            <ListItemText
              primary="Pusat Bantuan"
              secondary="TokoRame siap membantu temen-teman reseller. jam kerja Senin - Sabtu,Jam 08.00 - 17.00 WIB"
            />
            <ListItemSecondaryAction>
              <IconButton edge="end" size="small">
                <NavigateNextIcon />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
        </List>
      </div>
    </>
  );
}

export default Akun;
